import * as React from 'react';

const Header = () => (
   <div className="mini-cart-header">
      <span className="mini-cart-heading">{_js('My Cart')}</span>
   </div>
);

export default Header;
